import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import imgCL from "../assets/image/svg/Dashboard.svg";
const TransDashboard = () => {
  return (
    <>
      {/* <!-- Content Area --> */}
      <div className=" pt-13 pt-md-12 pb-13 pb-md-25 mx-md-6 rounded-10 mb-6">
        <Container>
          <Row className="align-items-center">
            <Col
              md="12"
              lg="12"
              className=""
              data-aos="zoom-in-down"
              data-aos-duration="1100"
            >
              {" "}
              <p
                className="gr-text-9 gr-text-color-opacity"
                style={{ textAlign: "center" }}
              >
                Pilot your usage of our APIs, monitor user engagement and adjust
                model parameters to suit your needs.
              </p>
              <div className="content-img text-right pr-10">
                <object
                  data={imgCL}
                  alt=""
                  aria-labelledby="monitor user engagement"
                  style={{ maxWidth: "70vw" }}
                  className="txn-dash-large"
                />
              </div>
            </Col>
            <Col xs="11" sm="12" md="6" lg="6">
              <div className="pl-lg-3 pl-xl-12 mt-12 mt-md-0 ">
                {/* <h2 className="gr-text-2 mb-7" style={{ fontSize: '2rem' }}>
Genify Dashboard
                </h2> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default TransDashboard;
